<div class="column">
    <div class="cell">
        <div class="round" *ngFor="let round of penalties[0].penalties" [class.scored]="round === 'Scored'" [class.missed]="round === 'Missed'"></div>
    </div>
    <div class="cell">
        <div class="round" *ngFor="let round of penalties[1].penalties" [class.scored]="round === 'Scored'" [class.missed]="round === 'Missed'"></div>
    </div>
</div>
<div class="column">
    <div class="cell">{{ score[0] }}</div>
    <div class="cell">{{ score[1] }}</div>
</div>
